import React, { useState, useRef, useEffect } from 'react';
import { Sun, Moon, MonitorSmartphone, Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const OPTIONS = [
  { value: 'light', label: 'Chiaro', Icon: Sun, hint: 'Sempre chiaro' },
  { value: 'dark', label: 'Scuro', Icon: Moon, hint: 'Sempre scuro' },
  { value: 'auto', label: 'Auto', Icon: MonitorSmartphone, hint: 'Chiaro di giorno, scuro dalle 18:00' },
];

const ThemeToggle = () => {
  const { mode, effective, setMode } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (!ref.current || !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const ActiveIcon = effective === 'dark' ? Moon : Sun;
  const activeOption = OPTIONS.find(o => o.value === mode);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        title={`Tema: ${activeOption?.label || 'Auto'}${mode === 'auto' ? ` (attuale: ${effective})` : ''}`}
        data-testid="theme-toggle-btn"
        className="flex items-center justify-center w-9 h-9 rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-100 transition dark:bg-slate-800 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-700"
      >
        <ActiveIcon className="w-4 h-4" />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-56 rounded-xl border border-slate-200 bg-white shadow-xl z-50 overflow-hidden dark:bg-slate-900 dark:border-slate-700"
          data-testid="theme-toggle-menu"
        >
          <div className="px-3 py-2 border-b border-slate-100 dark:border-slate-800">
            <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">Aspetto</p>
          </div>
          {OPTIONS.map(({ value, label, Icon, hint }) => (
            <button
              key={value}
              type="button"
              onClick={() => { setMode(value); setOpen(false); }}
              className={`w-full flex items-start gap-3 px-3 py-2.5 text-left hover:bg-slate-50 dark:hover:bg-slate-800 ${mode === value ? 'bg-slate-50 dark:bg-slate-800' : ''}`}
              data-testid={`theme-option-${value}`}
            >
              <div className={`mt-0.5 w-7 h-7 rounded-md flex items-center justify-center ${mode === value ? 'bg-indigo-100 text-indigo-600 dark:bg-indigo-500/20 dark:text-indigo-300' : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'}`}>
                <Icon className="w-3.5 h-3.5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-medium text-slate-900 dark:text-slate-100">{label}</span>
                  {mode === value && <Check className="w-3.5 h-3.5 text-indigo-600 dark:text-indigo-400" />}
                </div>
                <p className="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">{hint}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;
